import script from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=1d271ebf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d271ebf"]])

export default __exports__